import { NavLink, Outlet } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';

const TABS = [
  { to: '/settings/projects/', label: 'Projects' },
  { to: '/settings/keys/', label: 'API Keys' },
  { to: '/settings/account/', label: 'Account' },
];

export default function SettingsPage({ onLogout }) {
  return (
    <DashboardLayout title="Settings">
      <nav className="flex gap-1 mb-8 p-1 rounded-xl border border-theme-secondary bg-theme-secondary/40 w-fit">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) => `px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              isActive
                ? 'bg-theme-main text-theme-primary shadow-sm'
                : 'text-theme-text opacity-70 hover:opacity-100'
            }`}
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>

      <Outlet context={{ onLogout }} />
    </DashboardLayout>
  );
}
